export const SelectStateEnum = {
	Select: Symbol("select"),
	Remove: Symbol("remove")
};

